import { render, staticRenderFns } from "./TasksListGroupItem.vue?vue&type=template&id=350c3341&scoped=true"
import script from "./TasksListGroupItem.vue?vue&type=script&lang=js"
export * from "./TasksListGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c3341",
  null
  
)

export default component.exports